import React, { useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
  Box,
} from "@mui/material";
import { CircularProgressCustom } from "../../utils/muiCustomTheme";

interface EditHistoryTableProps {
  data?: any;
  isLoading?: boolean;
}

const dateFormatter = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "2-digit",
  year: "numeric",
});

const EditHistoryTable: React.FC<EditHistoryTableProps> = ({ data, isLoading }) => {
  const tableData = useMemo(() => {
    const historyData = data?.History;
    return Array.isArray(historyData) ? historyData : [];
  }, [data]);

  const columns = useMemo(
    () => [
      { field: "last_modified", headerName: "Last Edited" },
      { field: "last_modified_by", headerName: "Edited By" },
    ],
    []
  );

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
        <CircularProgressCustom />
      </Box>
    );
  }

  if (!tableData.length) {
    return (
      <div className="create-campaign__delivery-preview__status">
        No edit history found for this segment
      </div>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table sx={{ tableLayout: "fixed", width: "100%" }}>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell
                key={col.field}
                sx={{
                  fontWeight: 600,
                  whiteSpace: "nowrap",
                }}
              >
                {col.headerName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {tableData.map((row: any, index: number) => (
            <TableRow
              key={index}
              sx={{
                "&:hover": {
                  backgroundColor: "#FFEBF5",
                },
              }}
            >
              <TableCell>
                {row?.last_modified ? dateFormatter.format(new Date(row.last_modified)) : "-"}
              </TableCell>
              <TableCell>{row?.last_modified_by || "-"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EditHistoryTable;
